import * as firebase from 'firebase'
import { Store } from 'vuex';


export default {
  state: {
      showPopup:false,
      showImageLoader:false,
      cutScene:null,
      scanData:{x:0,y:0,r:0,g:0,b:0},
      scannedData:null,
      foundData:null,
  },
  mutations: {
    setScanData(state,payload){
      state.scanData=payload
    },
    setScannedData(state,payload){
      state.scannedData=payload
    },
    setFoundData(state,payload){
      state.foundData=payload
    },
    setCutScene(state,payload){
      state.cutScene=payload;
    },
    setShowPopup(state,payload){
      state.showPopup=payload
    },
    setShowImageLoader(state,payload){
      state.showImageLoader=payload
    }
  },
  actions: {
 
  },
  getters: {
    getShowPopup(state){
        return state.showPopup
    },
    getShowImageLoader(state){
      return state.showImageLoader
  },
  getCutScene(state){
    return state.cutScene
  },
  getScanData(state){
    return state.scanData
  },
  getScannedData(state){
    return state.scannedData
  },
  getFoundData(state){
    return state.foundData
  }
    
  }
}

